<script lang="ts">
	interface Props {
		url: string
		alt?: string
	}

	const { url, alt = '' }: Props = $props()

	let imageEl: HTMLImageElement | null = null
	let zoomed = $state(false)
	let mouseX = $state(50)
	let mouseY = $state(50)

	function toggleZoom(e: MouseEvent) {
		if (!imageEl) return
		zoomed = !zoomed
		if (zoomed) updateOrigin(e)
		else reset()
	}

	function reset() {
		mouseX = 50
		mouseY = 50
	}

	function updateOrigin(e: MouseEvent) {
		const rect = imageEl!.getBoundingClientRect()
		mouseX = ((e.clientX - rect.left) / rect.width) * 100
		mouseY = ((e.clientY - rect.top) / rect.height) * 100
	}

	function onMouseDown(e: MouseEvent) {
		if (!zoomed) return
		imageEl!.style.cursor = 'grabbing'
		updateOrigin(e)
	}

	function onMouseMove(e: MouseEvent) {
		if (!zoomed) return
		updateOrigin(e)
	}

	function onMouseUp() {
		if (!zoomed) return
		imageEl!.style.cursor = 'grab'
	}
</script>

<div class="zoom-container">
	<button
		type="button"
		class="zoom-button"
		onclick={toggleZoom}
		onmousedown={onMouseDown}
		onmousemove={onMouseMove}
		onmouseup={onMouseUp}
		aria-label={zoomed ? 'Zoom out image' : 'Zoom in image'}
	>
		<img
			bind:this={imageEl}
			src={url}
			{alt}
			draggable="false"
			style={`transform-origin: ${mouseX}% ${mouseY}%;
			        transform: scale(${zoomed ? 2 : 1});
			        transition: transform 0.25s ease-in-out, ${!zoomed ? 'transform-origin 0.25s ease-in-out' : null};
			        cursor: ${zoomed ? 'zoom-out' : 'zoom-in'}`}
		/>
	</button>
</div>

<style>
	.zoom-container {
		@apply relative flex items-center justify-center overflow-hidden w-full h-full;
	}

	.zoom-button {
		@apply flex w-auto h-full p-0 border-none bg-transparent overflow-hidden;
		display: block;
		cursor: zoom-in;
	}

	.zoom-button:focus {
		outline: none;
	}

	img {
		@apply w-auto h-full will-change-transform select-none;
		user-drag: none;
	}
</style>
